// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__35Sqy","footer":"ModalUpdate_footer__Bzhyv"};